import { GridActionHandlerBase } from "./grid-action-handler-base";

/**
 * Loads data, resetting the current grid filter and page
 */
export class LoadDataGridActionHandler extends GridActionHandlerBase {
  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(_payload: any): void {
    this.workspace.grid.applyFilter(null, null);
  }
}
